module.exports = __webpack_public_path__ + "img/弈剑男.fbf8016c.png";